import React from 'react';
import InputValidatorField from '../../../common/components/Inputs/InputValidatorField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { IsValidEmail, IsValidName } from '../../../../utils/Validators';
import { ThemeContext } from 'styled-components';
import { useContext } from 'react';
import InputPassword from "../../../common/components/Inputs/InputPassword";
import WithActions from "../../../common/components/Wrappers/WithActions";
import ButtonPrimary from "../../../common/components/Buttons/ButtonPrimary";
import DisabledFormState from "../../../common/components/Wrappers/DisabledFormState";
import TurnstileWidget from "../../../common/components/Turnstile/TurnstileWidget";

const SignupMiniForm = ({
    formData,
    onChangeAuthForm,
    onSubmit,
    disabled = false,
    isLoading = false,
}) => {
    const theme = useContext(ThemeContext);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isLoading) {
            return;
        }
        onSubmit();
    };

    if (disabled) {
        return <DisabledFormState message="Account Created" tooltip="Account Created" />
    }

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                minHeight: 0
            }}>
            <TurnstileWidget />

            {/* Form fields - Scrollable area */}
            <Box
                sx={{
                    flex: '1 1 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflowY: 'auto',
                    mb: 2
                }}
            >
                {!disabled && (
                    <WithActions
                        disabled={disabled || isLoading}
                        showSuccessButton={disabled}
                        successTooltip="confirmed"
                        inputType="text"
                        forceSpacing={true}
                        fullWidth
                    >
                        <InputValidatorField
                            name="name"
                            label="Name"
                            type="text"
                            value={formData.name || ''}
                            handleChange={onChangeAuthForm}
                            disabled={disabled}
                            isValidInput={IsValidName}
                            requirementsText="Please enter a name (max 50 characters)"
                            sx={{ mb: 2 }}
                        />
                    </WithActions>
                )}

                <WithActions
                disabled={disabled || isLoading}
                showSuccessButton={disabled}
                successTooltip="confirmed"
                inputType="text"
                forceSpacing={true}
                fullWidth
            >
                <InputValidatorField
                    name="email"
                    label="Email Address"
                    type="email"
                    value={formData.email || ''}
                    handleChange={onChangeAuthForm}
                    disabled={disabled}
                    isValidInput={IsValidEmail}
                    requirementsText="Please enter a valid email address"
                    sx={{ mb: 2 }}
                />
            </WithActions>
            <WithActions
                disabled={disabled || isLoading}
                showSuccessButton={disabled}
                successTooltip="confirmed"
                inputType="text"
                forceSpacing={true}
                fullWidth
            >
                <InputPassword
                    handleChange={onChangeAuthForm}
                    requirementsText={[
                        "",
                        <div>
                            Password must include:
                            <br />* 12 - 36 Characters
                            <br />* Uppercase & Lowercase letters
                            <br />* Numbers
                            <br />* One special character: ^$*.[]{}()?-\"!@#%&/\\,':;|_~`+=
                        </div>,
                        ""
                    ]}
                    autoComplete="new-password"
                />
            </WithActions>
            </Box>

            {/* Button - Pinned at bottom */}
            {!disabled && (
                <Box
                    sx={{
                        flexShrink: 0,
                        pt: 2
                    }}
                >
                    <WithActions forceSpacing={true} isButton={true}>
                        <ButtonPrimary type="submit" disabled={disabled || isLoading} >
                            Sign Up
                        </ButtonPrimary>
                    </WithActions>
                </Box>
            )}
        </Box>
    );
};

export default SignupMiniForm;
